import React, {useState, useEffect} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, isProvider, userToken, logout } from "../../features/user";
import { showMessage } from "../../features/common";

import axios from "axios";
import { API_200, API_201, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../Constants';
import {Trans, useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, navigateTo, showLoading } from "../../Helper"

import Frame from '../widgets/Frame';
import Background from '../widgets/Background';
import TextArea from '../widgets/TextArea';


export function Reviews() {
    const [state, setState] = useState({reviews:[], reviewed:false, review:'', errors:{}});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { id } = useParams();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);
    const isUserProvider = useSelector(isProvider);



    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, "/start");
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                if(id) {
                    getRreviews(id);
                } else {
                    navigate(-1);
                }
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getRreviews = async (id) => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(id?`${API_URL }/rewiews?providerId=${id}`:`${API_URL }/rewiews`, config);
            showLoading(dispatch, false);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                setState({
                    ...state,
                    reviews: reply.data.reviews,
                    reviewed: reply.data.reviewed
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                errorMessage = e.response.data["errors"][0];
            }
            if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                dispatch(showMessage({message : errorMessage}));
            }
        }
    }

    const handleChange = (e) => {
        delete state.errors[e.target.id];
        setState({
            ...state,
            [e.target.id]: e.target.value,
            errors: {}
        });
    };

    const toUTCDate = (dateValue) => {
        if(dateValue &&typeof dateValue !== 'string') {
            return new Date(Date.UTC(
                dateValue.getUTCFullYear(),
                dateValue.getUTCMonth(),
                dateValue.getUTCDate()
            ));
        }
        return dateValue;
    }

    const formatDate = (date) => {
        if(date) {
            date = toUTCDate((typeof date === 'string')?new Date(date.slice(0, 10)):date);
            try {
                return date ? date.toLocaleDateString(undefined, {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                }):'';
            } catch (e) {}
        }
        return '';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            showLoading(dispatch, true);
            let errorMessage = DEFAULT_ERROR_TEXT;
            
            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};
          
            const data = {review: state.review?.trim(), providerId: id};

            try {
                const reply = await axios.post(API_URL + '/rewiews', data, config);
                showLoading(dispatch, false);
                if(reply.hasOwnProperty('status') && reply.status === API_201) {
                    getRreviews(id);
                }
            } catch (e) {
                showLoading(dispatch, false);
                if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }

    };

    const validateForm = () => {
        const errors = {};
        if (!state.review?.trim()) {
            errors['review'] = 'review_error';
        }

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };

    


    return (
        <Frame showMenu={true} showNav={true} showBack={true}>
            <div className='main main-reviews'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        {state.reviews?<Background >
                            <div className='right-main-inner'>
                                <div className='center-div mt10 mb10'><img src={'/images/list_logo.png'} className='header-logo' alt=''/></div>
                                <div className='text-align-center font-30 font-bold'>{t('add_a_review')}</div>
                                <div className='center-div mt5'><img src={'/images/list_break.png'} className='width-90' alt=''/></div>

                                {state.reviews.map(review => (
                                    <div key={review._id} className='center-div mt30'>
                                        <div className='width-80'>
                                            <div className='font-20 font-bold'>{review.name}</div>
                                            <div className='font-15  mt5'>{formatDate(review.createdAt)}</div>
                                            <div className='font-18 font-bold mt5'>{review.review}</div>

                                            <div className='center-div mt40'><img src={'/images/list_break.png'} className='width-80' alt=''/></div>
                                        </div>                                    
                                    </div>
                                ))}


                                {!isUserProvider && !state.reviewed && <div className='center-div mt10'>
                                    <div className='width-80'>
                                        <div className='font-25 font-bold color-550952'>{t('add_a_review_2')}</div>
                                        <div className='font-20 color-550952 mt5'>{t('email_not_public')}</div>
                                        <div className='review mt15'>
                                            <TextArea className={`${state.errors.review?"error":""}`} id="review" placeholder={t("your_review")} footer={t('up_to_500_words')} value={state.review??''} onChange={(e) => handleChange(e)}/>
                                        </div>
                                        <div className='button mt20 mb40' onClick={(e) => handleSubmit(e)}>  <div>{t("send")}</div> </div>
                                    </div>
                                </div>}

                            </div>
                        </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}